//@flow
import React from 'react';
import { translate, type TFunction } from 'react-i18next';
import { IconButtonWithPopover } from 'common/components/core/button';
import Icon from 'common/components/core/icon';
import {
    PopoverTriggerEnum,
    PopoverPlaceEnum
} from 'common/components/core/popover/popOverFactory';
import StringUtils from 'common/utils/StringUtils';
import { dashboardColors } from 'common/enums/ColorEnum';
import theme from './Timeline.scss';

type Props = {
    t: TFunction,
    isVisible: boolean,
    fieldId: string,
    height: number,
    ganttType: string,
    onClick: (string, Event) => void
};

const ToggleButton = ({
    isVisible,
    fieldId,
    onClick,
    ganttType,
    height,
    t
}: Props) => {
    const ganttTypeText = StringUtils.toTitleCase(ganttType);
    return (
        <div style={{ height }}>
            <IconButtonWithPopover
                icon={
                    <Icon
                        icon={isVisible ? 'eye' : 'eye-hide'}
                        iconColor={dashboardColors.steel.name}
                        theme={theme}
                    />
                }
                fieldId={fieldId}
                theme={theme}
                onClick={onClick}
                popOverContent={
                    isVisible
                        ? t('hideTimeline', { ganttType: ganttTypeText })
                        : t('showTimeline', { ganttType: ganttTypeText })
                }
                triggerPopoverOn={PopoverTriggerEnum.Hover}
                preferPlace={PopoverPlaceEnum.Left}
            />
        </div>
    );
};

export default translate()(ToggleButton);
